import React from "react";
import { EC_2025 } from "../Data";
import "./EC.css";
const EC2025 = () => {
  return (
    <>
      {EC_2025.map((val) => {
        return (
          <div className="flex flex-col items-center justify-center p-8 bg-white dark:text-white dark:bg-gray-900 rounded-lg shadow-lg my-8">
            <div className="studentchapter-header text-green-500 py-4">
              <h2 className="text-center text-3xl uppercase font-semibold text-green-500">
                EXECUTIVE COMMITTEE - 2024 - 2025
              </h2>
            </div>
            <div className="studentchapter-header text-green-500 py-4">
              <h2 className="text-center text-3xl uppercase font-semibold text-green-500 mb-4">
                OUR BOARD
              </h2>
            </div>

            <div className=" grid grid-cols-1 gap-20  sm:grid-cols-1 md:grid-cols-3 md:gap-40 place-items-center dark:text-black">
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image1} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name1}</h3>
                  <h2 className="text-2xl uppercase">{val.Post1}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image2} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name2}</h3>
                  <h2 className="text-2xl uppercase">{val.Post2}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image3} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name3}</h3>
                  <h2 className="text-2xl uppercase">{val.Post3}</h2>
                </div>
              </div>
            </div>
            <div className="studentchapter-header text-green-500 py-4">
              <h2 className="text-center text-3xl uppercase font-semibold text-green-500 mb-4">
                OUR Associates
              </h2>
            </div>
            <div className="grid grid-cols-1 gap-20  sm:grid-cols-1 md:grid-cols-3 md:gap-40 place-items-center dark:text-black">
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image4} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name4}</h3>
                  <h2 className="text-2xl uppercase">{val.Post4}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image5} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name5}</h3>
                  <h2 className="text-2xl uppercase">{val.Post5}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image6} alt="" />
                </div>
                <div className="Ec_text">
                  <h3 className="text-3xl uppercase">{val.Name6}</h3>
                  <h2 className="text-2xl uppercase">{val.Post6}</h2>
                </div>
              </div>
            </div>
            <div className="studentchapter-header text-green-500 py-4">
              <h2 className="text-center text-3xl uppercase font-semibold text-green-500 mb-4">
                Our heads
              </h2>
            </div>
            <div className="grid grid-cols-1 gap-20  sm:grid-cols-1 md:grid-cols-3 md:gap-40 place-items-center dark:text-black">
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image7} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name7}</h3>
                  <h2 className="text-2xl uppercase">{val.Post7}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image8} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name8}</h3>
                  <h2 className="text-2xl uppercase">{val.Post8}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image9} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name9}</h3>
                  <h2 className="text-2xl uppercase">{val.Post9}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image10} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name10}</h3>
                  <h2 className="text-2xl uppercase">{val.Post10}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image11} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name11}</h3>
                  <h2 className="text-2xl uppercase">{val.Post11}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image12} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name12}</h3>
                  <h2 className="text-2xl uppercase">{val.Post12}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image13} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name13}</h3>
                  <h2 className="text-2xl uppercase">{val.Post13}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image14} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name14}</h3>
                  <h2 className="text-2xl uppercase">{val.Post14}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image15} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name15}</h3>
                  <h2 className="text-2xl uppercase">{val.Post15}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image16} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name16}</h3>
                  <h2 className="text-2xl uppercase">{val.Post16}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image17} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name17}</h3>
                  <h2 className="text-2xl uppercase">{val.Post17}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image18} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name18}</h3>
                  <h2 className="text-2xl uppercase">{val.Post18}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image19} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name19}</h3>
                  <h2 className="text-2xl uppercase">{val.Post19}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image20} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name20}</h3>
                  <h2 className="text-2xl uppercase">{val.Post20}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image21} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name21}</h3>
                  <h2 className="text-2xl uppercase">{val.Post21}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image22} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name22}</h3>
                  <h2 className="text-2xl uppercase">{val.Post22}</h2>
                </div>
              </div>
            </div>
            <div className="studentchapter-header text-green-500 py-4">
              <h2 className="text-center text-3xl uppercase font-semibold text-green-500 mb-4">
                Our Co-heads
              </h2>
            </div>
            <div className="grid grid-cols-1 gap-20  sm:grid-cols-1 md:grid-cols-3 md:gap-40 place-items-center dark:text-black">
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image23} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name23}</h3>
                  <h2 className="text-2xl uppercase">{val.Post23}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image24} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name24}</h3>
                  <h2 className="text-2xl uppercase">{val.Post24}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image25} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name25}</h3>
                  <h2 className="text-2xl uppercase">{val.Post25}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image26} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name26}</h3>
                  <h2 className="text-2xl uppercase">{val.Post26}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image27} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name27}</h3>
                  <h2 className="text-2xl uppercase">{val.Post27}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image28} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name28}</h3>
                  <h2 className="text-2xl uppercase">{val.Post28}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image29} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name29}</h3>
                  <h2 className="text-2xl uppercase">{val.Post29}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image30} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name30}</h3>
                  <h2 className="text-2xl uppercase">{val.Post30}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image31} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name31}</h3>
                  <h2 className="text-2xl uppercase">{val.Post31}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image32} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name32}</h3>
                  <h2 className="text-2xl uppercase">{val.Post32}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image33} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name33}</h3>
                  <h2 className="text-2xl uppercase">{val.Post33}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image34} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name34}</h3>
                  <h2 className="text-2xl uppercase">{val.Post34}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image35} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name35}</h3>
                  <h2 className="text-2xl uppercase">{val.Post35}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image36} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name36}</h3>
                  <h2 className="text-2xl uppercase">{val.Post36}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image37} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name37}</h3>
                  <h2 className="text-2xl uppercase">{val.Post37}</h2>
                </div>
              </div>
              <div className="Ec_container">
                <div className="Ec_image">
                  <img src={val.image38} alt="" />
                </div>
                <div className="Ec_text text-center">
                  <h3 className="text-3xl uppercase">{val.Name38}</h3>
                  <h2 className="text-2xl uppercase">{val.Post38}</h2>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default EC2025;
